import { RouteType } from "constants/RouteType";
import { MemberBankDetailsModel } from "model/screensModels/MemberBankDetailsModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { AuthService } from "services/auth/AuthService";

export class MemberBankDetailsService {
  // constructor() { }

  //To get member list
  static saveBankDetails = async (requestBody: MemberBankDetailsModel) => {
    const url = RouteType.ADMIN + RouteType.BANK + RouteType.STORE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

   //To get member list
   static getBankDetails = async (requestBody: RequestModel) => {
    const url = RouteType.ADMIN + RouteType.BANK;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static deleteBankDetails = async (requestBody: MemberBankDetailsModel) => {
    const url = RouteType.ADMIN + RouteType.BANK+ RouteType.DELETE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  // static getBankDetailsById = async (requestBody: MemberBankDetailsModel) => {
  //   const url = RouteType.ADMIN + RouteType.BANK+ RouteType.DELETE;
  //   const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
  //   return response;
  // };
  

}